import React from "react";
import { Input } from "../Input/Input";

const YourDetails = ({ handleChange, sectionStyles, formData, errors }) => {
  return (
    <section className={`p-3 mb-6 lg:p-5 mt-6  ${sectionStyles.alignSection}`}>
      <h2 className="text-2xl font-semibold">Your <span className="uppercase">Details</span></h2>

      <div className="mb-8">
        <h3 className="text-xl font-semibold uppercase mb-4 mt-5">Bride</h3>
        <div className="sm:space-y-0 lg:space-y-6">
          <div className="flex items-center justify-between">
            <Input
              title={
                <>
                  Full Name: <span className="text-red-500">*</span>
                </>
              }
              type="text"
              name="brideFullName"
              value={formData.brideFullName || ""}
              handleChange={handleChange}
              sectionStyles={sectionStyles.label}
              error={errors.brideFullName}
              divClassName="w-full"
              className="flex-1 border-t-0 border-r-0 border-l-0 border-b border-gray-400 focus:outline-none focus:ring-0 focus:border-black"
            />
          </div>
          <div className="lg:flex-row sm:justify-between items-center flex flex-col">
            <Input
               title={
                <>
                  Email: <span className="text-red-500">*</span>
                </>
              }
              type="email"
              name="brideEmail"
              value={formData.brideEmail || ""}
              handleChange={handleChange}
              sectionStyles={sectionStyles.label}
              error={errors.brideEmail}
              divClassName="w-full"
              className="flex-1 border-t-0 border-r-0 border-l-0 border-b border-gray-400 focus:outline-none focus:ring-0 focus:border-black"
            />
            <Input
              title="Phone:"
              type="text"
              name="bridePhone"
              value={formData.bridePhone || ""}
              handleChange={handleChange}
              sectionStyles={`sm:ml-0 lg:ml-6 ${sectionStyles.label}`}
              divClassName="w-full"
              className="flex-1 border-t-0 border-r-0 border-l-0 border-b border-gray-400 focus:outline-none focus:ring-0 focus:border-black"
            />
          </div>
          <div className="lg:flex-row sm:justify-between items-center flex flex-col">
            <Input
              title="Nationality:"
              type="text"
              name="brideNationality"
              value={formData.brideNationality || ""}
              handleChange={handleChange}
              sectionStyles={sectionStyles.label}
              divClassName="w-full"
              className="flex-1 border-t-0 border-r-0 border-l-0 border-b border-gray-400 focus:outline-none focus:ring-0 focus:border-black"
            />
            <Input
              title="Age:"
              type="text"
              name="brideAge"
              value={formData.brideAge || ""}
              handleChange={handleChange}
              sectionStyles={`sm:ml-0 lg:ml-6 ${sectionStyles.label}`}
              divClassName="w-full"
              className="flex-1 border-t-0 border-r-0 border-l-0 border-b border-gray-400 focus:outline-none focus:ring-0 focus:border-black"
            />
          </div>
        </div>
      </div>

      <div>
        <h3 className="text-xl font-semibold uppercase mb-4 mt-8">Groom</h3>
        <div className="sm:space-y-0 lg:space-y-6">
          <div className="lg:flex-row sm:justify-between items-center flex flex-col">
            <Input
                title={
                  <>
                    Full name: <span className="text-red-500">*</span>
                  </>
                }
              type="text"
              name="groomFullName"
              value={formData.groomFullName || ""}
              handleChange={handleChange}
              sectionStyles={sectionStyles.label}
              error={errors.groomFullName}
              divClassName="w-full"
              className="flex-1 border-t-0 border-r-0 border-l-0 border-b border-gray-400 focus:outline-none focus:ring-0 focus:border-black"
            />
          </div>
          <div className="lg:flex-row sm:justify-between items-center flex flex-col">
            <Input
                title={
                  <>
                    Email: <span className="text-red-500">*</span>
                  </>
                }
              type="email"
              name="groomEmail"
              value={formData.groomEmail || ""}
              handleChange={handleChange}
              sectionStyles={sectionStyles.label}
              error={errors.groomEmail}
              divClassName="w-full"
              className="flex-1 border-t-0 border-r-0 border-l-0 border-b border-gray-400 focus:outline-none focus:ring-0 focus:border-black"
            />
            <Input
              title="Phone:"
              type="text"
              name="groomPhone"
              value={formData.groomPhone || ""}
              handleChange={handleChange}
              sectionStyles={`sm:ml-0 lg:ml-6 ${sectionStyles.label}`}
              divClassName="w-full"
              className="flex-1 border-t-0 border-r-0 border-l-0 border-b border-gray-400 focus:outline-none focus:ring-0 focus:border-black"
            />
          </div>
          <div className="lg:flex-row sm:justify-between items-center flex flex-col">
            <Input
              title="Nationality:"
              type="text"
              name="groomNationality"
              value={formData.groomNationality || ""}
              handleChange={handleChange}
              sectionStyles={sectionStyles.label}
              divClassName="w-full"
              className="flex-1 border-t-0 border-r-0 border-l-0 border-b border-gray-400 focus:outline-none focus:ring-0 focus:border-black"
            />
            <Input
              title="Age:"
              type="text"
              name="groomAge"
              value={formData.groomAge || ""}
              handleChange={handleChange}
              sectionStyles={`sm:ml-0 lg:ml-6 ${sectionStyles.label}`}
              divClassName="w-full" 
              className="flex-1 border-t-0 border-r-0 border-l-0 border-b border-gray-400 focus:outline-none focus:ring-0 focus:border-black"
            />
          </div>
        </div>
      </div>
      <div className="mt-4 text-md">
  All fields with <span className="text-red-500">*</span> are required.
</div>
    </section>
  );
};

export default YourDetails;
